import React from "react";
import { useHistory } from "react-router-dom";

import BackIcon from "@/assets/images/icons2/icon--arrow.svg?component";
import { Button2 } from "@/ui2/atoms/Button";

export function BackToPatientProfile({ patientId }) {
  const history = useHistory();

  return (
    <Button2
      className="tw:-mb-1.5! tw:flex tw:items-center tw:gap-1 tw:place-self-start tw:text-text-tertiary"
      onPress={() => history.push(`/app/patient/${patientId}/profile/v2?selectedTab=Notes`)}
      rawChildren
      variant="link"
    >
      <BackIcon className="tw:-mt-1 tw:rotate-180" />
      Back to Patient Profile
    </Button2>
  );
}
